export type ReportFile = {
  id: number
  name: string
  reportMonthlyId: number
  reportQuarterlyId: number
}
